module.exports = __webpack_public_path__ + "static/media/ania-dietetyk.4516f586.png";